import { Controller } from "@hotwired/stimulus";

// Warns before the browser leaves a one-time secret (an API key right after it's created) until the
// user has copied it. Without this, a mistaken click loses the key for good — it can't be re-read.
export default class extends Controller {
  static targets = ["warning", "dismissed"];

  connect() {
    this.guarding = true;
    this.beforeUnload = (event) => {
      if (!this.guarding) return;
      // The message is browser-controlled; returnValue just opts into the prompt.
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", this.beforeUnload);
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  }

  // Copying the secret is the signal it's safely stored: stop guarding and confirm, but leave it
  // on screen so the user can still paste the setup command.
  release() {
    this.guarding = false;
    if (this.hasWarningTarget) this.warningTarget.classList.add("hidden");
    if (this.hasDismissedTarget)
      this.dismissedTarget.classList.remove("hidden");
  }
}
